import HeroImage from "../HeroImage";

export default function SignupImage() {
    return (
        <HeroImage imageUrl="/img/bicycle_handlebar_hero.jpg" paragraph="Welcome to Windpuls! Please sign up to experience the most sophisticated wind and weather measurement and analytics on the market." />
    )
}